module.exports = __webpack_public_path__ + "assets/img/26_872_big.a4cbcf84.jpg";